import type { FormField } from '../types';

type Lookup = NonNullable<NonNullable<FormField['enrichAnswer']>['lookups']>[number];

export const evaluateLookupRules = ({
  lookups,
  formValues
}: {
  lookups: Lookup[];
  formValues: Record<string, string | number | boolean | string[]>;
}): string | null => {
  for (const lookup of lookups) {
    const sourceValue = formValues[lookup.sourceField];
    const stringSourceValue = String(sourceValue ?? '');

    for (const rule of lookup.rules) {
      const match = rule.matchValue ?? '';

      switch (rule.operator) {
        case 'equal':
          if (stringSourceValue === match) {
            return rule.outputValue;
          }
          break;
        case 'notEqual':
          if (stringSourceValue !== match) {
            return rule.outputValue;
          }
          break;
        case 'contain':
          if (stringSourceValue.includes(match)) {
            return rule.outputValue;
          }
          break;
        case 'notContain':
          if (!stringSourceValue.includes(match)) {
            return rule.outputValue;
          }
          break;
        case 'startWith':
          if (stringSourceValue.startsWith(match)) {
            return rule.outputValue;
          }
          break;
        case 'endWith':
          if (stringSourceValue.endsWith(match)) {
            return rule.outputValue;
          }
          break;
        case 'greaterThan': {
          const sourceNum = parseFloat(sourceValue as string);
          const matchNum = parseFloat(match);

          if (!isNaN(sourceNum) && !isNaN(matchNum) && sourceNum > matchNum) {
            return rule.outputValue;
          }
          break;
        }
        case 'lessThan': {
          const sourceNum = parseFloat(sourceValue as string);
          const matchNum = parseFloat(match);

          if (!isNaN(sourceNum) && !isNaN(matchNum) && sourceNum < matchNum) {
            return rule.outputValue;
          }
          break;
        }
      }
    }
  }

  return null;
};
